import { IResponse, consumer, postFile, IBatchAssessment, IListProfile, IProfile } from "@bemap/utils";

const ENDPOINT = '/list-profiles'

export const createListProfiles = async (payload: FormData): Promise<IResponse> => {
  return postFile(ENDPOINT, payload);
}

export const getListProfiles = async (): Promise<IResponse> => {
  return consumer('GET', ENDPOINT);
}

export const getListProfile = async (id: number): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, id);
}

export const updateListProfile = async (payload: Partial<IListProfile>): Promise<IResponse> => {
  return consumer('PATCH', ENDPOINT, payload, payload.id);
}

export async function deleteListProfile(id: number): Promise<IResponse> {
  return consumer('DELETE', ENDPOINT, undefined, id);
}

export async function batchAssessment(id: number, payload: IBatchAssessment): Promise<IResponse> {
  return consumer('POST', ENDPOINT, payload, `${id}/send-assessments`);
}

export const addProfileToList = async (id: number, person: Partial<IProfile>): Promise<IResponse> => {
  return consumer('POST', ENDPOINT, person, `${id}/add-profile`);
}

export const removeProfileFromList = async (listId: number, profileId: number): Promise<IResponse> => {
  return consumer('POST', ENDPOINT, {}, `${listId}/remove-profile/${profileId}`);
}